// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  social_video: [
    {
      metric: 100,
      inHeader: true,
      label: 'Ad Effect Score',
      rowType: 'demphasized',
      dataFormat: '.,0',
      reverseStat: false,
      minSampleSize: 0
    },
    {
      label: 'IN-MARKET POTENTIAL',
      rowType: 'hb0'
    },
    {
      label: 'IMPACT',
      rowType: 'h0'
    },
    {
      metric: 101,
      label: 'Lift to Impression (Among Total)',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 102,
      label: 'Net Actions',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 103,
      label: 'Talk about the ad to friends or family',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 104,
      label: 'Go online for more information',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 105,
      label: 'Follow brand/show/movie on social media',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 106,
      label: 'Recommend the brand to friends or family',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 107,
      label: 'Watch any of the movies or TV shows featured',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 108,
      label: "Search for info about the shows/movies featured",
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 109,
      label: "Subscribe to/Upgrade current service (among total)",
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      label: 'NON-USER IMPACT',
      rowType: 'h0'
    },
    {
      metric: 110,
      label: `Non-Users' Lift to Consideration`,
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 111,
      label: 'Subscribe to service ',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      label: 'USER IMPACT',
      rowType: 'h0'
    },
    {
      metric: 112,
      label: `Users' Lift to Consideration`,
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 113,
      label: 'Likelihood of Subs to Stay',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 114,
      label: 'Upgrade current service ',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      label: 'CREATIVE DIAGNOSTICS',
      rowType: 'hb0'
    },
    {
      label: 'BRANDING',
      rowType: 'h0'
    },
    {
      metric: 115,
      label: 'Ease of Branding',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 116,
      label: 'Unique to this Brand',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      label: 'APPEAL',
      rowType: 'h0'
    },
    {
      metric: 117,
      label: 'Likes',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false
    },
    {
      metric: 118,
      label: 'Dislikes',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: true
    },
    {
      label: 'CREATIVE EFFICIENCY',
      rowType: 'h0'
    },
    {
      metric: 202,
      label: 'Category Connection',
      rowType: 'dh0',
      dataFormat: 'idx',
      reverseStat: false
    },
    {
      metric: 119,
      label: 'Piques my interest in new/different shows/movies',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 120,
      label: 'Entertainment trendsetter',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 121,
      label: 'Good original content',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 122,
      label: 'Brand Connection',
      rowType: 'dh0',
      dataFormat: 'idx',
      reverseStat: false
    },
    {
      metric: 123,
      label: 'High-quality entertainment service',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 124,
      label: 'Brand I can trust ',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 125,
      label: 'Premium',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 126,
      label: 'Good value for the money',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 127,
      label: 'Brand/Service I can’t live without ',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 128,
      label: 'Can replace cable/satellite',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 129,
      label: 'Mostly for adults',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 130,
      label: 'Relevance',
      rowType: 'dh0',
      dataFormat: 'idx',
      reverseStat: false
    },
    {
      metric: 131,
      label: 'Brand I want to be associated with',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 132,
      label: 'Tells me something new about this brand',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 133,
      label: 'Spoke directly to me',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 134,
      label: 'Relevant to me',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 135,
      label: 'Relatable people/situations',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 136,
      label: 'Makes me think of the brand in a new way',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 137,
      label: 'Addresses issues important to me',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 138,
      label: 'Engagement',
      rowType: 'dh0',
      dataFormat: 'idx',
      reverseStat: false
    },
    {
      metric: 139,
      label: 'Reassuring',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 140,
      label: 'Heartwarming',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 141,
      label: 'Worth seeing again',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 142,
      label: 'Clever',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 143,
      label: 'Entertaining',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 144,
      label: 'Unique',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 145,
      label: 'Attention-grabbing',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 146,
      label: 'Cognitive',
      rowType: 'dh0',
      dataFormat: 'idx',
      reverseStat: false
    },
    {
      metric: 147,
      label: 'Brand/Service helps me have fun',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 148,
      label: 'Represents diversity/inclusivity authentically',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 149,
      label: 'Informative',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 150,
      label: 'Good fit with brand',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 151,
      label: 'Credible message coming from this brand',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      label: 'Custom Ad Metrics',
      rowType: 'h0'
    },
    {
      metric: 152,
      label: 'Makes me feel something',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 153,
      label: 'Captivating ad',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 154,
      label: 'High quality ad',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 155,
      label: 'Bold/boundary pushing',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 156,
      label: 'Exciting/ builds anticipation',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 157,
      label: 'Humorous',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 158,
      label: 'Presents information at a good pace',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 159,
      label: 'Fun',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 160,
      label: 'Memorable',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 161,
      label: 'Worth talking about',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 162,
      label: 'Modern Brand/Service',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 163,
      label: 'Culturally relevant',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 164,
      label: 'On its way up',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 165,
      label: 'Clear',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 166,
      label: 'Confusing',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: true
    },
    {
      metric: 167,
      label: 'Annoying',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: true
    },
    {
      label: 'Custom Brand Perceptions',
      rowType: 'h0'
    },
    {
      metric: 168,
      label: 'Shows/movies with passion/intention',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 169,
      label: 'Enjoyable on surface, thoughtful deeper',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 170,
      label: 'Sets the bar of craftsmanship across genre',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 171,
      label: 'Consistently good movies/shows',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 172,
      label: 'Good choice of movies I like',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 173,
      label: 'Exclusive movies & TV shows',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 174,
      label: 'Brand/Service has captivating, attention grabbing entertainment',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 175,
      label: 'Different from others',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 176,
      label: 'For a variety of audiences/preferences',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 203,
      label: 'Makes me feel closer to brand',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      metric: 204,
      label: 'Delivers moments/stories that stick with you.',
      rowType: 'd0',
      dataFormat: '.,2',
      reverseStat: false
    },
    {
      label: 'Ad Barriers (among dislikers)',
      rowType: 'h0'
    },
    {
      metric: 177,
      label: 'Offensive',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 178,
      label: 'Confusing (barrier to liking)',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 179,
      label: 'Corny / too over-the-top',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 180,
      label: 'Feels cheaply made',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 181,
      label: 'Shows / movies featured',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 182,
      label: 'Characters featured',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 183,
      label: 'I don’t like the music',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 184,
      label: 'Dark / not colorful',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 185,
      label: 'Isn’t very visually engaging',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 186,
      label: 'Chaotic',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 187,
      label: 'I couldn’t tell what the ad was for',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 188,
      label: 'Too much info to take in',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 189,
      label: 'Long',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 190,
      label: 'Isn’t relevant to the whole family',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 191,
      label: 'Doesn’t tell me what’s available on platform',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 192,
      label: 'Not enough details price/subscription',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 193,
      label: 'Feels the same as other ads I’ve seen',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 194,
      label: 'Doesn’t capture the feeling I want',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 195,
      label: 'Boring / doesn’t make me feel anything',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 196,
      label: 'Unoriginal',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 197,
      label: 'I can’t relate to the message',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 198,
      label: 'Seen too many ads from this brand',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 199,
      label: 'Makes unrealistic claims',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 200,
      label: 'Boastful / cocky',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      metric: 201,
      label: 'Too salesey',
      rowType: 'd0',
      dataFormat: '%,1',
      reverseStat: false,
      minSampleSize: 40
    },
    {
      label: '',
      rowType: 'eol'
    }
  ]
}




// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/components/scorecard/MetricsLabels/metricsLabels.js